import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { PointPlan, ChangePageRequest } from 'src/lib/entity/gift-point'
import { ConsoleLogger } from 'src/lib/console-logger'
import { LiveUserAuthority } from 'src/lib/entity/live-user-authority'
import { StripeReq } from 'src/lib/entity/gift-point'
import { Subscription } from 'rxjs'
import { environment } from 'src/env/environment'

@Component({
  selector: 'maglive-gift-charge-for-page',
  templateUrl: './gift-charge-for-page.component.html',
  styleUrls: ['./gift-charge-for-page.component.scss'],
})
export class GiftChargeForPageComponent implements OnInit, OnDestroy {
  @Input() isShowChargePage: boolean
  @Input() authority: LiveUserAuthority | undefined
  @Output() changePageEvent = new EventEmitter<ChangePageRequest>()

  /* Subscription */
  private getPointPlansSub: Subscription | undefined
  private postCheckoutSettionSub: Subscription | undefined

  pointPlans: PointPlan[] | 'NOT_FOUND'
  selectedPointPlan: PointPlan
  redirectUrl = window.location.href
  mag2PointTermsUrl = environment.baseURL.mag2www + 'terms/mag2point.html'

  constructor(private logger: ConsoleLogger) {}

  ngOnInit(): void {
    // ロールバック対策
    // history.pushState(null, null, location.href)
    // window.addEventListener('popstate', this.browserBack)

    this.redirectUrl = this.excludeRouteParams()
    this.getPointPlansSub = MagliveApiClient.getPointPlans().subscribe(
      (value) => {
        this.pointPlans = value
        if (this.pointPlans !== 'NOT_FOUND' && this.pointPlans.length !== 0) {
          this.pointPlans = this.pointPlans.filter((x) => {
            return x.amount >= 50
          })
        }
        this.logger.info(this.constructor.name, 'ngOnInit', 'pointPlans', value)
      }
    )
  }

  ngOnDestroy() {
    // window.removeEventListener('popstate', this.browserBack)
    if (this.getPointPlansSub) {
      this.getPointPlansSub.unsubscribe()
    }
    if (this.postCheckoutSettionSub) {
      this.postCheckoutSettionSub.unsubscribe()
    }
  }

  /**
   * ポイントプランの選択処理
   */
  selectPointPlan(pointPlan: PointPlan): void {
    this.selectedPointPlan = pointPlan
    this.logger.info(
      this.constructor.name,
      'selectPointPlan',
      'selectedPointPlan',
      pointPlan
    )
  }

  /**
   * stripe決済開始。checkout-sessionを生成する
   */
  startPointChargeProcess() {
    const request: StripeReq = {
      successUrl: this.redirectUrl + '?success=true',
      cancelUrl: this.redirectUrl + '?cancel=true',
      pointPlanId: this.selectedPointPlan.pointPlanId,
    }
    this.postCheckoutSettionSub = MagliveApiClient.postCheckoutSession(
      request
    ).subscribe((value) => {
      if (value !== 'NOT_FOUND') {
        window.location.href = value.url
        this.logger.info(
          this.constructor.name,
          'postCheckoutSession',
          'response',
          value
        )
      } else {
        console.error('Stripe api response is not found')
      }
    })
  }

  closeChargePage() {
    this.changePageEvent.emit({ name: 'MANAGE' })
  }

  /**
   * URLからルートパラメータを除去する
   * 同一ウィンドウで複数回チャージが行わる場合を考慮
   */
  private excludeRouteParams(): string {
    let pattern = /[\?]/
    let result = this.redirectUrl.split(pattern)
    this.logger.info(
      this.constructor.name,
      'excludeRouteParams',
      'currentUrl',
      result[0]
    )
    return result[0]
  }

  /**
   * ブラウザバック押下時の挙動。同期遷移させない。
   */
  // private browserBack = (e) => {
  //   e.preventDefault()
  //   history.go(1)
  //   this.changePageEvent.emit({name: 'MANAGE'})
  //   console.log('detail')
  //   e.stopImmediatePropagation()
  // }
}
